import React, { useState, useContext, useRef } from "react";
import { Grid, Button, Menu, MenuItem } from "@mui/material";
import { MainContext } from "../App";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { storage } from "../@shared/firebase/config"; // Ensure Firebase is initialized

const CSVUploader = ({ onUpload, setCardType, type, close }) => {
  const { setMessage, setError, setInfo, setSuccess, setLoading } =
    useContext(MainContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const fileInputRef = useRef(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => {
    close();
    setAnchorEl(null);
  };

  const handleFileUpload = async (event) => {
    handleClose();
    const file = event.target.files[0];
    if (!file) {
      setError(true);
      setMessage("No file selected.");
      return;
    }

    setInfo(true);
    setMessage("Uploading file, please wait...");

    // const now = new Date();
    // const folderName = `${now.toLocaleString("default", {
    //   month: "long",
    // })} ${now.getFullYear()}`; // Example: "March 2025"
    // const filePath = `playOnTestFiles/${folderName}/events-upload-${now.getTime()}.csv`; //TODO: remove testing code
    // const fileRef = ref(storage, filePath);

    try {
      //   const uploadTask = uploadBytesResumable(fileRef, file);
      //   uploadTask.on(
      //     "state_changed",
      //     null,
      //     (error) => {
      //       console.error("Upload failed", error);
      //       setError(true);
      //       setMessage("File upload failed.");
      //     },
      //     async () => {
      //       const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
      //   console.log("✅ File Uploaded: ", downloadURL);

      // Continue with file processing
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const parsedData = parseCSV(text);
        if (parsedData.length > 0) {
          onUpload(parsedData, type); // ⬅️ Ensure `handleUpload()` in `EventList.js` is called!
          setSuccess(true);
          setMessage("File uploaded & events processed successfully!");
        } else {
          setError(true);
          setMessage("CSV upload failed. Check file format.");
        }
      };
      reader.readAsText(file);
      // }
      //   );
    } catch (error) {
      console.error("File Upload Error:", error);
      setError(true);
      setMessage("Error uploading file.");
    }
  };

  const parseCSV = (csvText) => {
    const lines = csvText
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line);
    if (lines.length < 2) return [];

    const headers = lines[0].split(",").map((header) => header.trim());

    return lines.slice(1).map((line) => {
      // Use regex to handle quoted values correctly
      const values = [];
      let current = "";
      let insideQuotes = false;

      for (let char of line) {
        if (char === '"' && insideQuotes) {
          insideQuotes = false;
        } else if (char === '"' && !insideQuotes) {
          insideQuotes = true;
        } else if (char === "," && !insideQuotes) {
          values.push(current.trim());
          current = "";
          continue;
        }
        current += char;
      }
      values.push(current.trim());

      // Ensure values match the number of headers
      while (values.length < headers.length) values.push("");
      while (values.length > headers.length) values.pop();

      return headers.reduce((acc, header, index) => {
        acc[header] = values[index]?.replace(/^"|"$/g, ""); // Remove extra quotes
        return acc;
      }, {});
    });
  };

  return (
    <Grid item container xs={12}>
      {/* Button to open menu */}
      <Button fullWidth size="small" variant="contained" onClick={handleClick}>
        Add Card
      </Button>

      {/* Dropdown Menu */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            setCardType(type);
            handleClose();
          }}
        >
          Create New Card
        </MenuItem>
        <MenuItem onClick={() => fileInputRef.current.click()}>
          Import From CSV
        </MenuItem>
      </Menu>

      {/* Hidden File Input */}
      <input
        type="file"
        accept=".csv"
        ref={fileInputRef}
        onChange={handleFileUpload}
        style={{ display: "none" }}
      />
    </Grid>
  );
};

export default CSVUploader;
